// export default [{
//     original: `/get-image/examples/v2/0.jpg`,
//     description: '一个西装革履的教授在介绍成果，白色背景'
// }, {
//     original: `/get-image/examples/v2/1.jpg`,
//     description: '一只可爱的狐狸，高清摄影'
// }, {
//     original: `/get-image/examples/v2/2.jpg`,
//     description: '一群人穿着彩色衬衫站在沙滩上'
// }, {
//     original: `/get-image/examples/v2/3.jpg`,
//     description: '两个人坐在餐桌前吃披萨'
// }, {
//     original: `/get-image/examples/v2/4.jpg`,
//     description: '大熊猫，油画'
// }, {
//     original: '/get-image/examples/v2/5.jpg',
//     description: '小男孩坐在长椅上戴着帽子'
// }, {
//     original: '/get-image/examples/v2/6.jpg',
//     description: '网球天王费德勒'
// }, {
//     original: '/get-image/examples/v2/7.jpg',
//     description: '蓝眼睛的动漫女孩'
// }]

export default [{
    original: `/get-image/da958161e4dca3a6/1655385132674/2.jpg`,
    description: '带墨镜的熊猫，高清摄影'
}, {
    original: `/get-image/d587dcb75563f254/1652746927167/1.jpg`,
    description: '茶杯里的一只小熊猫，高清摄影'
}, {
    original: `/get-image/fa2936eb12afc19f/1655112881667/2.jpg`,
    description: '吃比特币的猫，高清摄影'
}, {
    original: `/get-image/b2a0e636e69df95f/1655446758231/4.jpg`,
    description: '彩虹头发的女孩，高清摄影'
}, {
    original: `/get-image/93117d46397a2635/1655238335624/5.jpg`,
    description: '狗吃花朵，高清摄影'
}, {
    original: '/get-image/1fbdf885220ccd0b/1654094267090/4.jpg',
    description: '北极光，现实的数字艺术，高清摄影'
}, {
    original: '/get-image/f65ffe7d3892ff6f/1655139778616/2.jpg',
    description: '中国小女孩写作业，高清摄影'
}, {
    original: '/get-image/42bb5b275cf0a074/1654714244525/2.jpg',
    description: '被霧包圍的山，中国水墨画'
}, {
    original: `/get-image/fe06d135e36a9bf5/1653905642633/6.jpg`,
    description: '病毒'
}, {
    original: '/get-image/7a57e264f333c93a/1652967454655/2.jpg',
    description: '波罗的海，高清摄影'
}, {
    original: '/get-image/97c17d85cb4d6d81/1653886169917/1.jpg',
    description: '博物馆走廊，高清摄影'
}, {
    original: '/get-image/4f3cf5d89106f127/1653858052755/5.jpg',
    description: '可爱的动漫女孩'
}]